module.exports = __webpack_public_path__ + "img/journey2.5f3795da.png";